import { forwardRef, InputHTMLAttributes } from "react";
import { clsxm } from "@/utils/clsxm";

interface IProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string | boolean;
  errorMessage?: string | boolean;
}

const Input = forwardRef<HTMLInputElement, IProps>(
  ({ label, id, className, errorMessage, error, value, ...props }, ref) => {
    const inputId =
      id || props.name || `input-${Math.random().toString(36).slice(2, 9)}`;
    const currentErrorMessage = error || errorMessage;

    return (
      <div className="flex flex-col w-full min-w-0">
        {label && (
          <label
            htmlFor={inputId}
            className="mb-1 text-sm font-light text-new-design-gray-500/50 whitespace-nowrap sm:text-base"
          >
            {label}
          </label>
        )}
        <input
          id={inputId}
          ref={ref}
          {...props}
          value={value || ""}
          className={clsxm(
            "resize-none text-base text-black10 py-[11px] px-5 rounded-2xl border border-new-design-gray-600/[0.08] outline-none",
            "hover:border-new-design-purple-300 focus:border-new-design-purple-300 placeholder:!text-new-design-gray-500/50",
            currentErrorMessage && "!border-new-design-red-400",
            className
          )}
        />

        {currentErrorMessage && (
          <span className="text-left block mt-2 text-sm text-new-design-red-400">
            {currentErrorMessage}
          </span>
        )}
      </div>
    );
  }
);

export { Input };
